import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FetchCustomerDetailsService {
  serverUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getSecretValue(secretName: string): Observable<any> {
    const url = this.serverUrl + 'getSecretValue';

    const body = {
      secretName: secretName
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, body, { headers: headers });
  }
}
